import { withLDProvider } from 'launchdarkly-react-client-sdk';

import { launchDarklyConfig } from '../constants';

export const withFeatureFlagProvider = withLDProvider(launchDarklyConfig);
